module.exports = __webpack_public_path__ + "src/assets/pl.a1fe67ab.png";